(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name aeroLineCrew.constant:applicationConstants
	 *
	 * @description
	 *
	 */

	/**
	 * If any pages newly linked to the menu structure, should update the
	 * 'pageBelongsToTheMenu' property of the corresponding page link in
	 * 'application-service-service.js'. 'pageBelongsToTheMenu' : indicates the
	 * category of the page according side menu structure. Helps to show the
	 * active menu icon of the selected page.
	 */

	angular.module('aeroLineCrew').value('applicationConstants', {
		SETTINGS : {
			DATE_FORMAT : 'DD/MM/YYYY',
			DATE_TIME_FORMAT : 'DD/MM/YYYY HH:mm', 
			WEEK_START_DAY : 'SUNDAY',
			CREW_BASE_AIRPORT : '',
			TIME_FORMAT : 'HH:mm',
		},
		TRAINING_COLOR_MAP : {
			SIM : "#009393",
			GRT : "#63a69f",
			CHK : "#0D8231",
			FLT : "#02a688",
			LNC : "#37a447"
		},
		TRAINING_STATUS : {
			CONFIRMED : "Confirmed",
			TENTATIVE : "Tentative",
			CANCELLED : "Cancelled"
		},
		EDITOR_STATUS : {
			ADD : "add",
			EDIT : "edit",
			UPDATE : "update",
			DELETE : "delete"
		},
		UPDATE_FLIGHT_SOURCE : {
          MANAGE_FLIGHT : "manage_flight",
          FLIGHT_PUNCTUALITY : "flight_punctuality",
          JOURNEY_LOG : "journey_log",
          FLIGHT_WATCH : "flight_watch"
		}

	});
}());
